import React from 'react'
import './Our_Services.css'
import Smart_Finance_Solutions_card from './Smart_Finance_Solutions_card/Smart_Finance_Solutions_card'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Grid, Pagination } from 'swiper/modules'
import "swiper/css";
import "swiper/css/grid";
import "swiper/css/pagination";
import RedRoundBtn from '../../Common_Component/Common_Btn/RedRoundBtn/RedRoundBtn'

const Our_Services = () => {
    const scrollToSection = (id, offset = 100) => {

        const section = document.getElementById(id);
        if (section) {
            const top = section.getBoundingClientRect().top + window.scrollY - offset;
            window.scrollTo({ top, behavior: "smooth" });
        }
    };


    const slides = Array.from({ length: 15 }, (_, index) => index + 1);

    const data = [
        {
            img: "/assets/Image/Home/Our_Services/img2.png",
            text: "Personal Finance Guidance",
        },
        {
            img: "/assets/Image/Home/Our_Services/img.png",
            text: "Home Finance Support",
        },
        {
            img: "/assets/Image/Home/Our_Services/img5.png",
            text: "Business Funding Assistance",
        },




        // {
        //     img: "/assets/Image/Home/Our_Services/img3.png",
        //     text: "CAR LOAN",
        // },
        // {
        //     img: "/assets/Image/Home/Our_Services/img4.png",
        //     text: "CREDIT CARD LOAN",
        // },

        // {
        //     img: "/assets/Image/Home/Our_Services/img6.png",
        //     text: "GOLD LOAN",
        // },
        // {
        //     img: "/assets/Image/Home/Our_Services/img7.png",
        //     text: "MICRO LOAN",
        // },
        // {
        //     img: "/assets/Image/Home/Our_Services/img8.png",
        //     text: "PROPERTY LOAN",
        // },

    ]

    return (
        <section className='Our_Services'>

            <div className='container'>

                <div className='heading_main_div'>
                    <div className='first_div'>
                        <p className='section_heading'>Financial Facilitation Services</p>
                    </div>
                    <div className='second_div'>
                        <p className='text'>LOANS
                            {/* & INSURANCE */}
                        </p>
                    </div>
                </div>


                <div className="Smart_Finance_Solutions_holder">
                    <div className="row">
                        <div className="col-xl-1 col-md-1 col-2">
                            <div className="Loan_heading_holder">LOANS</div>
                        </div>

                        <div className="col-md-10 col-9">
                            <Swiper
                                slidesPerView={4}
                                // grid={{
                                //     rows: 2,
                                // }}
                                spaceBetween={50}
                                pagination={{
                                    clickable: true,
                                }}
                                modules={[Pagination]}
                                loop={true}
                                className="mySwiper Smart_Finance_Solutions_slider"
                                breakpoints={{
                                    0: {
                                        slidesPerView: 1.2, // 4 slides on larger screens
                                        spaceBetween: 15,
                                    },

                                    485: {
                                        slidesPerView: 2, // 4 slides on larger screens
                                        spaceBetween: 15,
                                    },

                                    575: {
                                        slidesPerView: 2, // 4 slides on larger screens
                                        spaceBetween: 15,
                                    },

                                    768: {
                                        slidesPerView: 2, // 4 slides on larger screens
                                        spaceBetween: 15,
                                    },

                                    992: {
                                        slidesPerView: 3, // 4 slides on larger screens
                                        spaceBetween: 15,
                                    },

                                    1024: {
                                        slidesPerView: 3, // 4 slides on larger screens
                                        spaceBetween: 15,
                                    },

                                    1200: {
                                        slidesPerView: 3, // 4 slides on larger screens
                                        spaceBetween: 15,
                                    },

                                    1300: {
                                        slidesPerView: 4, // 4 slides on larger screens
                                        spaceBetween: 15,
                                    },
                                }}
                            >
                                {data?.map((item) => (
                                    <SwiperSlide>
                                        <Smart_Finance_Solutions_card img={item?.img} loan={item?.text} />
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>

                    <div className="btn_holder" style={{ width: "fit-content", margin: "0px auto" }}>
                        <RedRoundBtn btn_name="Consult an Advisor" onClick={() => scrollToSection("key_feature")} />
                    </div>
                </div>

            </div>

        </section>
    )
}

export default Our_Services
